export default defineNuxtRouteMiddleware(async (to) => {
  // This state is shared across the server-side render for a single request.
  const isEarlyAccessUser = useState("is-early-access-user", () => false);
  const kudoearlyCookie = useCookie<string>("kudoearly");
  const planCookie = useCookie<string>("kudoplan");

  const path = to.path.replace(/\/+$/, "");

  const commercialRoutes = ["/early-access", "/early-access/signup"];
  const protectedRoutes = ["/trial", "/register", "/developer-trial", "/referrals", "/get-a-demo", "/talk-to-an-expert", "/become-a-partner", "/partners/jobadder", "/partners/lend", "/partners/ecommerce-equation-customers", "/partners/ecommerce-equation-ee"];
  const protectedFolders = ["/resources/support"];

  // Check for cm and plan query parameters
  if (!!to.query.cm && !!to.query.plan && !to.query._storyblok) {
    planCookie.value = to.query.plan as string;
    kudoearlyCookie.value = "yes";
  }

  // Determine the state first, based on the cookie from the request or the current route.
  let shouldBeEarlyAccess = kudoearlyCookie.value === "yes";

  if (commercialRoutes.includes(path)) {
    kudoearlyCookie.value = "yes";
    shouldBeEarlyAccess = true;
  }

  // Set the request-scoped state so components can react to it on the initial server render and on client.
  isEarlyAccessUser.value = shouldBeEarlyAccess;

  if (protectedFolders.some((folder) => path.includes(folder) && !isEarlyAccessUser.value && !to.query._storyblok)) {
    // return navigateTo("/", { external: true });
  }

  // If the user has the early access cookie and tries to visit a protected route, redirect them.
  if (protectedRoutes.includes(path) && isEarlyAccessUser.value && !to.query._storyblok) {
    return navigateTo("/early-access", { external: true });
  }
});
